module.exports = __webpack_public_path__ + "media/images/country_flags/hn-8f34ace6e357ac84bfa082805484ea79.png";